'use strict';
angular.module('headModule', []).controller('HeaderController', [
    '$scope',
    '$element',
    '$q',
    '$filter',
    '$rootScope',
    '$state',
    '$location',
    '$timeout',
    'trsHttpService',
    'permissionService',
    'globleParamsSet',
    'nameChange',
    'messagePublishService',
    '$aside',
    '$sessionStorage',
    'publicToolService',
    'loginService',
    function (
        $scope,
        $element,
        $q,
        $filter,
        $rootScope,
        $state,
        $location,
        $timeout,
        trsHttpService,
        permissionService,
        globleParamsSet,
        nameChange,
        messagePublishService,
        $aside,
        $sessionStorage,
        publicToolService,
        loginService
    ) {
        initStatus();
        initData();

        /**
         * [selectModule description]选择模块
         * @param   {[type]}  moduleName  [moduleName description]模块名称
         * @return  {[type]}              [return description]
         */
        $scope.selectModule = function (moduleName) {
            $scope.currModule = moduleName;
        };

        /**
         * [initStatus description]
         * @return  {[type]}  [return description]
         */
        function initStatus() {
            $scope.data = {
                globalName: nameChange.globalName,
                user: {},
                headerName: '',
                globalSearch: '', // 全局搜索关键词
                headInfo: {},
            };
            $scope.currModule = $location.path().split('/')[2];
            $scope.headParams = {
                serviceid: 'mlf_extuser',
                methodname: 'getUserHeadPic',
            };
            $scope.headPic = '';
            $scope.status = {
                showGlobalSearch: false
            };
        }

        /**
         * [initData description]初始化数据
         * @return {[type]} [description]
         */
        function initData() {
            messagePublishService.subscribe(
                'CurrLoginUserHaveGet',
                function () {
                    $scope.data.user = $sessionStorage.get('curUserInfo');
                    globleParamsSet.getTokenService($scope.data.user.TENANTID);
                    isAdministrator();
                    getDateReminderNum();
                },
                $scope
            );
            messagePublishService.subscribe(
                'changeTopModule',
                function (event, data) {
                    $scope.currModule = data;
                },
                $scope
            );
            getBasicAccess().then(function () {
                autoLocation();
                cacheUserRightChannel();
            });
            getNetworkResourceConfig();
            getOperateConfig();
            getHeaderInfo();
        }

        /**
         * [getNetworkResourceConfig description] 获取网络资源模块配置
         * @return  {[type]}  [return description]
         */
        function getHeaderInfo() {
            publicToolService.getHeaderInfo($scope);
        }

        /**
         * [getNetworkResourceConfig description] 获取网络资源模块配置
         * @return  {[type]}  [return description]
         */
        function getNetworkResourceConfig(){
            publicToolService.queryModeconfiguration('networkResource');
            publicToolService.getModeconfiguration('networkResource', 'networkResource').then((config) => {
                $scope.status.networkResource = config;
            });
        }

        /**
         * [getManageConfig description] 获取运营中心配置项
         * @return  {[type]}  [return description]
         */
        function getOperateConfig(){
            publicToolService.queryModeconfiguration('operationCenter');
            publicToolService.getModeconfiguration('operateCenter', 'operationCenter').then((config) => {
                $scope.status.operate = config;
            });
        }

        /**
         * [showGlobalSearchInput description] 点击逻辑
         * @return  {[type]}  [return description]
         */

        $(document).on('click', function (e) {
            var target = e.target || e.srcElement;
            var globalInput = document.getElementById('globalInput');
            var globalIcon = document.getElementById('globalIcon');
            var globalImg = document.getElementById('globalImg');
            var loginImgWrap = document.getElementById('loginImgWrap');
            $timeout(function() {
                if (target === loginImgWrap) {
                    $scope.status.isShowDropdown = true;
                    return;
                }
                if (target !== loginImgWrap) {
                    $scope.status.isShowDropdown = false;
                }
                if (target === globalIcon) {
                    $scope.status.showGlobalSearch = true;
                    return;
                }
                if (target !== globalInput && target !== globalImg) {
                    $scope.status.showGlobalSearch = false;
                }
            });
        });

        /**
         * [goToGlobalSearch description]
         * @param   {[type]}  ev  [ev description]
         * @return  {[type]}      [return description]
         */
        $scope.goToGlobalSearch = function (ev) {
            if ((ev && ev.keyCode === 13) || !ev) {
                var url = $state.href('globalSearch');
                window.open(url + '?keyWords=' + $scope.data.globalSearch);
                $scope.data.globalSearch = '';
            }
        };

        /**
         * [autoLocation description] 自动定位
         * @return {[type]} [description]
         */
        function autoLocation() {
            $timeout(function () {
                if ($state.current.name !== 'front') {
                    return;
                } // 非只精确定位到front 返回
                if ($element.find('.editing_center').length > 0) {
                    // 当创作分发有权限时，定位到创作分发
                    $element.find('.editing_center')[0].click();
                    return;
                }
                $element.find('.main_module')[0].click(); // 当创作分发没权限时，找到第一个模块，定位到第一个模块（如，策划资源）
            });
        }

        /**
         * [logout description]退出登录
         * @return{[type]}[return description]
         */
        $scope.logout = function () {
            globleParamsSet.clearStroge();
            $('#unreadPrompt_js').hide(); // 关闭传稿提示框
            $.ajax({
                url: '/wcm/logout.jsp',
                method: 'get',
                async: false,
                success: function () { 
                    // loginService.getCurrLoginUser(); // 调用一次接口执行退出跳转逻辑
                },
                error: function () {
                    window.name = '';
                    loginService.getCurrLoginUser(); // 调用一次接口执行退出跳转逻辑
                    // $state.go('front', {

                    // }, { reload: true }); 
                },
            });
            // $timeout(() => {
            //     $state.go('front', {}, { reload: true }); 
            // }, 1000);
        };

        $scope.showDate = function () {
            LazyLoad.css(['./lib/ngAnimate/animation.css'], function () {
                // Pre-fetch an external template populated with a custom scope
                var myOtherAside = $aside({
                    template: 'dateReminder/dateReminder.html',
                    controller: 'dateReminderCtrl',
                    placement: 'right',
                    animation: 'am-slide-right',
                    container: 'body'
                });
                // Show when some event occurs (use $promise property to ensure the template has been loaded)
                myOtherAside.$promise.then(function () {
                    myOtherAside.show();
                });
            });
        };

        /**
         * [getBasicAccess description]description：获取一级模块访问权限
         * @return  {[type]}  [return description]
         */
        function getBasicAccess() {
            var deffer = $q.defer();
            if ($rootScope.status && $rootScope.status.basicAccess) {
                deffer.resolve();
                return deffer.promise;
            }
            var params = {
                serviceid: 'mlf_metadataright',
                methodname: 'queryMlfChildModalsWithRight',
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                var basicAccess = {};
                for (var i = 0; i < data.length; i++) {
                    basicAccess[data[i]] = true;
                }
                $rootScope.status.basicAccess = basicAccess;
                deffer.resolve();
            });
            return deffer.promise;
        }

        /**
         * [goToMessageCenter description] 进入消息中心
         * @return {[type]} [description]
         */
        $scope.goToMessageCenter = function () {
            $state.go('front.mc', {}, { reload: 'front.mc' });
            $scope.currModule = 'mc';
        };

        /**
         * [getDateReminderNum description] 获取日期提醒数量
         * @return  {[type]}          [return description]
         */
        function getDateReminderNum() {
            var params = {
                serviceid: 'daily',
                method: 'countArrange',
                selectDate: $filter('date')(new Date(), 'yyyy-MM-dd'),
                tenantId: $scope.data.user.TENANTID,
                userId: $scope.data.user.ID
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getMessageUrl(), params, 'GET').then(function (res) {
                if (res && res.datas) {
                    $scope.status.dateReminderNum = res.datas.arrangenum > 99 ? '99+' : res.datas.arrangenum;
                }
            });
        }

        /**
         * [isAdministrator description]判断是不是系统管理员
         *
         * @return  {[type]}  [return description]
         */
        function isAdministrator() {
            permissionService
                .isAdministrator()
                .then(function (data) {
                    $scope.status.isAdministrator = data;
                })
                .finally(() => {
                    if (!$scope.status.isAdministrator) {
                        // getMessageNum();
                    }
                });
        }
        $rootScope.$on('updateMessage', (ev, data) => {
            if (data === 'update') {
                isAdministrator();
            }
        });
        
        /**
         * [cacheUserRightChannel 通知后端缓存栏目]
         *
         * @return  {[type]}  [return description]
         */
        function cacheUserRightChannel() {
            if (window.name !== 'isReload') {
                window.name = 'isReload';
                const params = {
                    serviceid: 'mlf_rightchannel',
                    methodname: 'cacheUserRightChannel'
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get');
            }
        }
    },
]);
